module.exports = __webpack_public_path__ + "16ee3e38032c9dc5dbea7c3368791282.svg";